/** The empty place in the phone/tablet top bar (between the page name and the bell) a page may fill with its own control (the Map's project chip). */
export const TOP_SLOT_ID = "cy-top-slot";
